const FormFieldInputCheckbox = ({
    label,
    name,
    defaultChecked,
    onChange,
    onClick,
    className = '',
    additionalProps = {},
    styles
}) => {
    return (
        <div
            className={`formField formFieldInputCheckbox ${className}`}
            style={styles}
        >
            {label && <label>{label}</label>}
            <input
                type="checkbox"
                name={name}
                defaultChecked={defaultChecked}
                onChange={onChange}
                onClick={onClick}
                {...additionalProps}
            />
        </div>
    )
}

export default FormFieldInputCheckbox